
export const ACCOUNT_ERROR_MESSAGES = {
  NAME_REQ: 'Please enter name',
  EMAIL_REQ: 'Please enter email address',
  INVALID_EMAIL: 'Please enter a valid email address',
  PASSWORD_REQ: "Please enter password",
  INVALID_PASSWORD: "Password must contain at least 1 uppercase, 1 lowercase, 1 number, 1 special character, minimum 8 and maximum 20 characters",
  NO_SPACE_PASSWORD: "Password can't start or end with a blank space",
}

export const PASSWORD_ERROR_MESSAGES = {
  OLD_PASSWORD_REQ: "Please enter old password",
  INVALID_OLD_PASSWORD: "Old password must contain at least 1 uppercase, 1 lowercase, 1 number, 1 special character, minimum 8 and maximum 20 characters",
  NO_SPACE_OLD_PASSWORD: "Old password can't start or end with a blank space",
  NEW_PASSWORD_REQ: "Please enter new password",
  INVALID_NEW_PASSWORD: "New password must contain at least 1 uppercase, 1 lowercase, 1 number, 1 special character, minimum 8 and maximum 20 characters",
  NO_SPACE_NEW_PASSWORD: "New password can't start or end with a blank space",
  C_PASSWORD_REQ: "Please enter confirm new password",
  INVALID_C_PASSWORD: "Confirm new password must contain at least 1 uppercase, 1 lowercase, 1 number, 1 special character, minimum 8 and maximum 20 characters",
  NO_SPACE_C_PASSWORD: "Confirm new password can't start or end with a blank space",
  CONFORM_PASSWORD_MATCH_ERR: "New password and confirm new password not matched",
  OLD_NEW_PASSWORD_MATCH_ERR: "Old & New password can't be the same",
  WRONG_OLD_PASSWORD: "Entered old password was incorrect",
}

export const LISTING_COMMON_MESSAGES = {
  ACTIVE_TITLE: "Unblock Confirmation",
  BLOCK_TITLE: "Block Confirmation",
  DELETE_TITLE: "Delete Confirmation",
  ACTIVE_MSG: "Are you sure you want to unblock?",
  BLOCK_MSG: "Are you sure you want to block?",
  DELETE_MSG: "Are you sure you want to delete?",
};

export const LOGOUT_POPUP_MESSAGES = {
  TITLE: 'Logout Confirmation',
  MESSAGE: 'Are you sure you want to logout?',
};

export const IMPORT_FILES_POPUP_MESSAGES = {
  TITLE: 'Import Confirmation',
  MESSAGE: 'Are you sure you want to import selected file?',
};

export const REASON_MESSAGE = {
  REASON_LIMIT: 500,
  REASON_EMPTY: "Please enter reason for ending the class",
  REASON_MAX_LIMIT_MESSAGE: "Reason can not be more than 500 characters"
};

export const INVALID_DATE_TIME_ERROR = {
  INVALID_DATE: "Please select valid date",
  INVALID_TIME: "Please select valid time",
}

export const QUIZ_SUBMIT_MSG = 'Quiz has been submitted successfully';

export const INVALID_ID_ERROR = 'Invalid ID';
export const DATA_NOT_FOUND = 'Data not found';
export const MAP_LOCATION_ERROR = 'Oops! Something went wrong. Please select location';
export const NO_ACTION = "You can't perform this action";
export const NO_EDIT_ACTION = (pageType = 'class') => `You can't update this ${pageType}`;
export const SOMETHING_WRONG = 'Something went wrong. Please try again';
export const NO_INTERNET = 'No Internet Connection';
export const TIME_OUT = 'Connection timed out. Please retry';
export const INTERNAL_SERVER_ERROR = "Couldn't connect to the server. Please try again";
export const SELECT_VALID_FILE = "Please select Csv file";
export const VALID_CSV_FILE_SIZE = "Please select file of less than 5 MB";

export const IMAGE_REQUIRED = 'Please select a image';

export const MAX_IMAGE_SIZE = 10;
export const MAX_VIDEO_SIZE = 200;
export const MAX_AUDIO_SIZE = 30;

export const CLASS_MEDIA_LIMITS = {
  MAX_POST_MEDIA: 2,
  MAX_POST_VIDEOS: 1,
  MAX_POST_IMAGES: 1
}

export const IMAGE_FORMAT = 'image/jpeg,image/png,image/jpg';
export const VIDEO_FORMAT = 'video/mp4,video/webm,video/ogg';
export const AUDIO_FORMAT = 'audio/wav,audio/mpeg,audio/mp3';

export const DOCUMENT_FORMAT = 'Only pdf and doc are allowed';
export const DOCUMENT_ACCEPT = '.doc,.pdf'

export const POST_MEDIA_ERROR = `Only ${IMAGE_FORMAT} images and ${VIDEO_FORMAT} videos are allowed`;

export const invalidImageError = (format = 'jpeg/png') => `Only ${format} images are allowed`;
export const invalidVideoError = (format = 'mp4/webm/ogg') => `Only ${format} videos are allowed`;
export const invalidAudioError = (format = 'mp3/wav/mpeg') => `Only ${format} audios are allowed`;

export const invalidFileSize = (size = 2) => `File size can not be more than ${size} MB`;

export const TIME_ERROR = {
  FUTURE_TIME: 'Please select future time',
  SET_MIN_TIME: (time = 30) => `Set ${time} min time Interval from the start time`
}

export const CATEGORY_ERROR_MESSAGES = {
  CATEGORY_NAME_REQ: 'Please enter category name'

}


export const SPECIFY_REASON = 'Please specify a reason';
export const INVALID_REASON_TEXT = 'HTML or script tags are not allowed in reason';


export const TAGS_MESSAGES = {
  LIMIT: 'You can only add upto 5 tags',
  TAGS_5: 'You can only add upto 5 tags',
  CATEGORY_5: 'You can only add upto 5 categories'
}

export enum HIDE_UNHIDE_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

// export const STATUS ={
//   BLOCKED: 'Blocked',
//   UNBLOCKED: 'Unblocked',
//   DELETED: 'Delete'
// }
// export const STATUS = [
//   { name: "Active", value: "UN_BLOCKED" },
//   { name: "Blocked", value: "BLOCKED" }
// ];



export const DATE_TYPES = {
  SHORT_TIME: 'h:mm a',
  MEDIUM_DATE: 'MMM d, yyyy',
  FULL_DATE: 'EE, MMM d, yyyy',
  DATE_WITH_TIME: 'MMM d, y - hh:mm a',
}


export const DELETED = {
  confirm: (type, count = 1) => `Do you want to delete ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been deleted successfully`
};

export const UNBLOCKED = {
  confirm: (type, count = 1) => `Do you want to unblock ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been unblocked successfully`
};

export const BLOCKED = {
  confirm: (type, count = 1) => `Do you want to block ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been blocked successfully`
};

export const PUBLISHED = {
  confirm: (type, count = 1) => `Do you want to publish ${count == 1 ? 'this' : 'these'} ${type.toLowerCase()}?`,
  success: (type, count = 1) => `${type} ${count == 1 ? 'has' : 'have'} been published successfully`
};






